import { useEffect } from "react";
import "./FooterMob.css";
import TC3L from "../ReuseComponent/TCLines/TC3L";
import { Link } from "react-router-dom";
import ButtonContact from "../ButtonContact/ButtonContact";
import FooterLine from "../../Assets/Svg/Footer/FooterLine.svg";
import IconFB from "../../Assets/Svg/Footer/IconFB.svg";
import IconIns from "../../Assets/Svg/Footer/IconIns.svg";
import IconLinkedin from "../../Assets/Svg/Footer/IconLinkedin.svg";
import Logo from "../../Assets/Svg/Header/MilkyLogo.svg";
import FooterMapPin from "../../Assets/Svg/Footer/FooterMapPin.svg";
import { RoutesEn } from "../Hooks/RoutesDynamic/RoutesDynamic";
import { useSelector, useDispatch } from "react-redux";
import { fetchFooterData } from "../../redux/FooterSlice";
import { LoaderWrap } from "../GlobalLoader/LoaderWrap";
export default function EnglishFooterMobile() {
  const dispatch = useDispatch();
  const { data } = useSelector((state) => state.footer);

  useEffect(() => {
    if (!data || data.length === 0) {
      dispatch(fetchFooterData({ lang: "en" }));
    }
  }, [dispatch, data]);

  const section1 = data?.find((s) => s.id === 1);
  const section2 = data?.find((s) => s.id === 2);
  const section3 = data?.find((s) => s.id === 3);

  return (
    <>
      <LoaderWrap>
        <div className="Footer_Container_Mob">
          <FooterMobS1 section1={section1} />
          <FooterMobS2 section1={section1} />
          <FooterMobS3 />
          <FooterMobS4 section2={section2} />
          <FooterMobS5 section2={section2} />
          <FooterMobS6 section3={section3} />
          <FooterMobS7 />
        </div>
      </LoaderWrap>
    </>
  );
}

function FooterMobS1({ section1 }) {
  return (
    <>
      <div className="FooterMobS1">
        <TC3L Head={section1?.title} Title={section1?.description} />
      </div>
    </>
  );
}

function FooterMobS2({ section1 }) {
  return (
    <>
      <div className="FooterMobS2">
        <div className="FooterButton">
          <div>{section1?.links && section1?.links.length > 0 && <ButtonContact Text={section1?.links[0]?.name} Path={section1?.links[0]?.link} />}</div>
        </div>
      </div>
    </>
  );
}

function FooterMobS3() {
  return (
    <>
      <div className="FooterMobS3">
        <div className="FooterL">
          <img src={FooterLine} alt="" className="FooterLineMob" />
        </div>
      </div>
    </>
  );
}

function FooterMobS4({ section2 }) {
  return (
    <>
      <div className="FooterMobS4">
        <TC3L Title={section2?.title} Color={"#fff"} />
      </div>
    </>
  );
}

function FooterMobS5({ section2 }) {
  const socialIcons = {
    facebook: IconFB,
    instagram: IconIns,
    linkedin: IconLinkedin,
  };

  return (
    <>
      <div className="FooterMobS5">
        <TC3L Head={section2?.description} Color={"#fff"} TextTransForm={"uppercase"} />
        <div className="FooterMobP5P2">
          <div className="Footer_P2SCMob">
            {section2?.links &&
              section2?.links.map((link, index) => (
                <a key={index} href={link.link} target="_blank" rel="noopener noreferrer">
                  <img src={socialIcons[link.name.toLowerCase()]} alt={link.name} />
                </a>
              ))}
          </div>
        </div>
      </div>
    </>
  );
}

function FooterMobS6({ section3 }) {
  return (
    <>
      <div className="FooterMobS8">
        <div className="FP3BT TFut24PxPC">{section3?.title}</div>
        {section3?.links && section3?.links.length > 0 && (
          <a href={section3?.links[0]?.link} target="_blank" rel="noopener noreferrer" className="FMS8P1 TFut16PxPCUC">
            {section3?.links[0]?.name}
            <img src={FooterMapPin} alt="Map Pin" className="FooterMapPinMob" />
          </a>
        )}
      </div>
    </>
  );
}

function FooterMobS7() {
  return (
    <>
      <div className="FooterMobS9">
        <div>
          <Link to={RoutesEn.Home}>
            <img src={Logo} alt="" className="FMS9Img" />
          </Link>
        </div>
        <div>
          <TC3L Head="@2025 All Right Reserved To MILKY’S" Color={"#fff"} />
        </div>
      </div>
    </>
  );
}
